import { hasApiClientFieldErrors } from "@imi/api-client/ApiClientError.js";
import { get, mapKeys } from "radashi";

export type ApiErrors = ReturnType<typeof parseApiError>;

type ParseApiIssuesOptions = {
  error: unknown;

  // When there are zod issues returned by the API, it can happen that the path of the issue doesn't match
  // the form field name. We can provide path aliases to map the API issue paths to the form field names.
  pathAliases?: Record<string, string>;
};

export function getApiErrorMessage(
  error: unknown,
  fallbackMessage = "An unknown error occurred",
) {
  return (
    get<string>(error, "data") ||
    get<string>(error, "message") ||
    fallbackMessage
  );
}

export function parseApiError({ error, pathAliases }: ParseApiIssuesOptions) {
  if (!hasApiClientFieldErrors(error)) {
    return { form: getApiErrorMessage(error) };
  }
  return {
    fields: mapKeys(error.data.fieldErrors, (key) =>
      get(pathAliases, key, key),
    ),
  };
}
